import { render, staticRenderFns } from "./ReorderItineraryBlock.vue?vue&type=template&id=b546a8ba&"
import script from "./ReorderItineraryBlock.vue?vue&type=script&lang=js&"
export * from "./ReorderItineraryBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports